module.exports = __webpack_public_path__ + "static/lipowiec_koscielny-a9cde915ced6c8397413d083fce9aa2f.png";